module.exports = __webpack_public_path__ + "img/scrypt.49cf71f0.png";